import GeoTargeting from './geo-targeting';

export default GeoTargeting;
